import React from "react";
import { Box } from "@mui/material";
import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { UpcomingEvents } from "../../../feature/PurchaseFlow/UpcomingEvents";
import { TEvent } from "src/shared/types/globalStotre.types";
import { throttleTime } from "src/utils/utils";
import { useTeamConfig } from "../TeamConfigProvider";

export interface ViewEventsModalState {
  isOpen: boolean;
  events: TEvent[];
}

export interface UseViewEventsModalReturn {
  isOpen: boolean;
  title: string;
  events: TEvent[];
  set: (state: Partial<ViewEventsModalState>) => void;
  reset: () => void;
}

export const useViewEventsModal = createState<UseViewEventsModalReturn>({
  isOpen: false,
  title: "",
  events: [],
} as unknown as UseViewEventsModalReturn);

export function ViewEventsModal() {
  const viewEventsModal = useViewEventsModal();
  const { LANDING_PAGE_SETTINGS } = useTeamConfig();

  const onClose = () => {
    viewEventsModal.set({ isOpen: false });
    throttleTime(300, () => {
      viewEventsModal.reset();
    });
  };

  return (
    <DynamicModal
      hideTitleIcon
      isOpen={viewEventsModal.isOpen}
      title={viewEventsModal.title}
      renderBody={() => {
        return (
          <Box p={2}>
            <UpcomingEvents
              title=" "
              events={viewEventsModal.events}
              showAllEvents={LANDING_PAGE_SETTINGS?.SHOW_ALL_EVENTS_UNDER_PASS}
            />
          </Box>
        );
      }}
      renderFooter={() => null}
      onClose={onClose}
      slot={{
        secondaryButton: {
          isHidden: true,
        },
        primaryButton: {
          label: "CLOSE",
          onClick: onClose,
        },
      }}
    />
  );
}
